import React, { useEffect, useState } from 'react';
import { AddReductionType, Reduction } from '../model/Reduction';
import { showMessage } from '../services/popup';
import { addReduction, deleteReduction, getReductions } from '../services/service';

const ReductionTab: React.FC = () => {
  const [reductions, setReductions] = useState<Reduction[]>([]);
  const [update, needUpdate] = useState(0);

  const [promotionCode, setPromotionCode] = useState('');
  const [reductionCode, setReductionCode] = useState('');
  const [promotionText, setPromotionText] = useState('');
  const [reductionText, setReductionText] = useState('');
  const [reductionDays, setReductionDays] = useState('');
  const [reductionUnlimited, setReductionUnlimited] = useState(false);
  const [promotionValue, setPromotionValue] = useState('');
  const [reductionValue, setReductionValue] = useState('');

  const goUpdate = () => needUpdate((update + 1) % 1000);

  const getReductionValue = (value: number): number => parseFloat(value.toPrecision(2)) * 100;

  const removeReduction = async (id: string) => {
    await deleteReduction(id);
    goUpdate();
  };

  const addPromotion = async (prom: boolean) => {
    let date = undefined;

    if (!prom && !reductionUnlimited) {
      const r = parseInt(reductionDays);
      if (r <= 0) {
        showMessage(`'${reductionDays}' doit etre un nombre de jour, ou bien Illimite doit etre coche.`);
        return;
      }
      date = new Date();
      date.setDate(date.getDate() + r);
    }

    const text = prom ? promotionText : reductionText;
    const code = prom ? promotionCode : reductionCode;
    const value = prom ? promotionValue : reductionValue;

    if (prom && (text?.length ?? 0) === 0) {
      showMessage('La promotion doit avoir un texte.');
      return;
    }

    if ((code?.length ?? 0) === 0) {
      showMessage('La reduction doit avoir un code.');
      return;
    }

    const v = parseInt(value);
    if (v <= 0 || v > 100) {
      showMessage('La valeur de reduction est incorrecte: elle doit etre entre 1 et 100');
      return;
    }

    try {
      const prec = parseFloat((v / 100).toPrecision(2));
      const result = await addReduction(prec, code, date, text, reductionUnlimited);
      if (result.result === AddReductionType.OK) {
        goUpdate();
      } else {
        showMessage('Impossible d\'ajouter cette reduction: ' + AddReductionType[result.result].toString());
      }
    } catch {
      showMessage('Une erreur est survenue.');
    }
  };

  useEffect(() => {
    const get = async () => setReductions(await getReductions());
    get();
  }, [update]);

  const promotions = reductions.filter((s) => s.date == null);
  const promotion = promotions.length > 0 ? promotions[0] : null;

  return (
    <div className="page-stack">
      <section className="panel">
        <div className="panel-head"><h3>Promotion active</h3></div>
        {promotion === null ? (
          <div className="form-grid">
            <input placeholder="Code promo" value={promotionCode} onChange={(e) => setPromotionCode(e.target.value)} />
            <input placeholder="Texte promo" value={promotionText} onChange={(e) => setPromotionText(e.target.value)} />
            <input type="number" placeholder="Reduction %" value={promotionValue} onChange={(e) => setPromotionValue(e.target.value)} />
            <button className="primary-btn" onClick={() => addPromotion(true)}>Ajouter</button>
          </div>
        ) : (
          <div className="row-between card-inline">
            <div>
              <div className="mono">{promotion.code}</div>
              <p>{promotion.text}</p>
            </div>
            <button className="ghost-btn danger" onClick={() => removeReduction(promotion.code)}>Supprimer</button>
          </div>
        )}
      </section>

      <section className="panel">
        <div className="panel-head"><h3>Reductions</h3></div>
        <div className="form-grid wide">
          <input placeholder="Code reduction" value={reductionCode} onChange={(e) => setReductionCode(e.target.value)} />
          <input placeholder="Texte reduction" value={reductionText} onChange={(e) => setReductionText(e.target.value)} />
          <input type="number" placeholder="Jours de validite" value={reductionDays} onChange={(e) => setReductionDays(e.target.value)} />
          <input type="number" placeholder="Reduction %" value={reductionValue} onChange={(e) => setReductionValue(e.target.value)} />
          <label className="checkbox-wrap">
            <input type="checkbox" checked={reductionUnlimited} onChange={(e) => setReductionUnlimited(e.target.checked)} /> Illimite
          </label>
          <button className="primary-btn" onClick={() => addPromotion(false)}>Ajouter</button>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Texte</th>
                <th>Validite</th>
                <th>Valeur</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {reductions.filter((s) => s.date || s.unlimited).map((s, i) => (
                <tr key={i}>
                  <td className="mono">{s.code}</td>
                  <td>{s.text}</td>
                  <td>{s.unlimited ? 'Illimite' : `Expire le ${s.date ? new Date(s.date).toLocaleDateString() : ''}`}</td>
                  <td>{getReductionValue(s.value)} %</td>
                  <td><button className="ghost-btn danger" onClick={() => removeReduction(s.code)}>Supprimer</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default ReductionTab;
